export default __webpack_public_path__ + "static/media/ic_virgin_islands.2800d600.svg";